/**
 * Detailed Test Results — print layout (thin wrapper).
 *
 * Per the design conversation, the actual rendering lives in the
 * shared `components/detailedTestResults/ViewRoot.tsx` component
 * so it can be reused by a future native screen view. This file
 * is intentionally minimal — it only exists so the print-page
 * dispatcher can register a print-specific entry point matching
 * the pattern used by VariantQuality and RunDetail layouts.
 */
import { DetailedTestResultsView } from '@/components/detailedTestResults/ViewRoot'
import type { DetailedTestResultsViewModel } from '@/print/types'

interface DetailedTestResultsLayoutProps {
  viewModel: DetailedTestResultsViewModel
}

export function DetailedTestResultsLayout({
  viewModel,
}: DetailedTestResultsLayoutProps) {
  return <DetailedTestResultsView viewModel={viewModel} />
}
